const getWarehouseUrlFriendlyAddress = (address) => {
  var _a;
  const cityFormatted = ((_a = address == null ? void 0 : address.city) == null ? void 0 : _a.toLowerCase().replace(/\s+/g, "-")) || "-";
  const territoryOrCountryOriginal = (address == null ? void 0 : address.territory) || (address == null ? void 0 : address.countryName);
  const territoryOrCountryFormatted = (territoryOrCountryOriginal == null ? void 0 : territoryOrCountryOriginal.toLowerCase().replace(/\s+/g, "-")) || "-";
  return {
    city: cityFormatted,
    territoryOrCountry: territoryOrCountryFormatted
  };
};
export {
  getWarehouseUrlFriendlyAddress
};
